import { useContext } from "react";
import CustomTabs from "../../commons/components/CustomTabs";
import useControlTabs from "../../hooks/useControlTabs";
import StoreTypeTabs from "./StoreTypeTabs";
import styles from "./store-management.module.scss";
import { AppContext } from "../../contexts/AppContext";
import { STORE_TYPE } from "../../commons/constants/store";
import PrimaryButton from "../../commons/components/PrimaryButton/PrimaryButton";
import { useNavigate } from "react-router-dom";
import { routers } from "../../commons/constants/routers";
import { MODES } from "../../commons/constants/user";

export enum STORE_TYPE_TABS {
  ALL = "1",
  FOOD_DELIVERY = "2",
  SURPLUS = "3",
}

const StoreManagement = () => {
  const { user, allStores, foodDeliveryStores, surplusStores } = useContext(AppContext);
  const { activeTab, onChange } = useControlTabs(STORE_TYPE_TABS.ALL);
  const navigate = useNavigate();
  const isAdmin = user?.merchant_role?.id === MODES.ADMIN;

  const Tabs = [
    { title: `All (${allStores.total || 0})`, key: STORE_TYPE_TABS.ALL, children: <div></div> },
    {
      title: `Delivery Stores (${foodDeliveryStores.total || 0})`,
      key: STORE_TYPE_TABS.FOOD_DELIVERY,
      children: <div></div>,
    },
    {
      title: `Surplus Store (${surplusStores.total || 0})`,
      key: STORE_TYPE_TABS.SURPLUS,
      children: <div></div>,
    },
  ];

  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.titleWrapper}>
          <div className={styles.title}>Store List</div>
          {isAdmin && (
            <PrimaryButton className={styles.createStoreBtn} onClick={() => navigate(routers.STORES.CREATE_STORE)}>
              Create store
            </PrimaryButton>
          )}
        </div>
        <CustomTabs
          isParentTab={true}
          tabStyle={styles.customStoreTypeTab}
          activeTab={activeTab}
          onChange={onChange}
          tabs={Tabs}
        >
          <StoreTypeTabs activeTypeTab={activeTab} />
        </CustomTabs>
      </div>
    </>
  );
};

export default StoreManagement;
